/**
 * Created by pzf on 2018/12/26
 *
 */
import BasicLayout from './BasicLayout';

export default BasicLayout;